import React from "react";
import { Link } from "react-router-dom";
import { useSiteData } from "../lib/hooks";
import { fileUrl } from "../lib/api";
import { Reveal, Overline } from "../components/site/Reveal";
import PageHeader from "../components/site/PageHeader";
import { ArrowRight } from "lucide-react";

const IMG = (s, k) => fileUrl(s?.images?.[k]);

export default function Experiences() {
  const s = useSiteData();
  const events = [
    { t: "Weddings", k: "wedding", d: "Grand celebrations with custom menus and live counters.", span: "lg:col-span-2 lg:row-span-2" },
    { t: "Receptions", k: "toast", d: "Elegant evenings, flawless service.", span: "" },
    { t: "Corporate Events", k: "corporate", d: "Conferences, launches and offsites.", span: "" },
    { t: "Birthdays", k: "sweets", d: "Joyful spreads for every age.", span: "" },
    { t: "Private Gatherings", k: "chef", d: "Intimate dinners, curated.", span: "" },
    { t: "Live Counters", k: "flame", d: "Theatre on the plate.", span: "lg:col-span-2" },
  ];
  return (
    <div>
      <PageHeader overline="Experiences & Events" title={<>Every occasion has a <span className="italic gold-text">flavour.</span></>}
        subtitle="Weddings, receptions, corporate events, private celebrations and social gatherings — catered with care." image={IMG(s, "wedding")} />

      <section className="py-24 bg-ivory">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 auto-rows-[240px] sm:auto-rows-[260px]">
            {events.map((e, i) => (
              <Reveal key={e.t} delay={(i % 4) * 0.07} className={e.span}>
                <div className="group relative overflow-hidden rounded-3xl w-full h-full">
                  <img src={IMG(s, e.k)} alt={e.t} className="w-full h-full object-cover img-zoom brightness-[0.8]" />
                  <div className="absolute inset-0 bg-gradient-to-t from-velvet/85 to-transparent" />
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="font-serif text-ivory text-3xl mb-1">{e.t}</h3>
                    <p className="text-ivory/70 text-sm">{e.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative min-h-[70vh] flex items-center overflow-hidden">
        <img src={IMG(s, "wedding2")} alt="Wedding" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-velvet/90 to-transparent" />
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 py-20">
          <Reveal className="max-w-lg">
            <Overline>The Wedding Table</Overline>
            <h2 className="font-serif text-ivory text-4xl sm:text-6xl mt-5 mb-6 leading-[1.03]">Your day. Your people. <span className="italic gold-text">Your table.</span></h2>
            <p className="text-ivory/75 mb-8">Custom menus, buffet planning, live counters and guest-scale catering for the celebration of a lifetime.</p>
            <Link to="/quote-builder" className="btn-gold">Plan Your Wedding <ArrowRight className="w-4 h-4" /></Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
